module.exports = __webpack_public_path__ + "static/media/straven_7.72d81bbf.jpg";